export enum LicensesBlockEnum {
    TestActive = 'activeTrialLicences',
    TestAvailable = 'availableTrialLicences',
    LicensesWithLimits = 'licenseWithLimits',
    AdditionalLicenses = 'licenseWithoutLimits',
}
